<template>
  <el-radio-group class="switch-content" v-model="internalValue" @change="onJobSwitchPrivateClick">
    <div ref="selectedBackground" class="selected-background"></div>
    <el-radio-button ref="leftSwitch"  :label="leftLabelValue">
      {{ leftLabel }}
    </el-radio-button>
    <el-radio-button ref="rightSwitch"  :label="rightLabelValue">
      {{ rightLabel }}
    </el-radio-button>
  </el-radio-group>
</template>

<script>
export default {
  props: {
    value: {
    },
    leftLabel: {
      type: String,
      required: true
    },
    leftLabelValue: {
      type: String,
      default: 'left'
    },
    rightLabel: {
      type: String,
      required: true
    },
    rightLabelValue: {
      type: String,
      default: 'right'
    }
  },
  data () {
    return {
      internalValue: '',
      firstMountedJobSwitch: true
    }
  },
  computed: {
  },
  created () {
    this.internalValue = this.value
  },
  mounted () {
    this.changeTabWidth()
  },
  methods: {
    onJobSwitchPrivateClick () {
      this.changeTabWidth()
    },
    changeTabWidth () {
      const leftSwitchWidth = this.$refs.leftSwitch.$el.offsetWidth
      const rightSwitchWidth = this.$refs.rightSwitch.$el.offsetWidth
      if (this.internalValue === this.rightLabelValue) {
        this.$refs.selectedBackground.style.left = `${leftSwitchWidth}px`
        this.$refs.selectedBackground.style.width = `${rightSwitchWidth}px`
      } else {
        this.$refs.selectedBackground.style.left = '0px'
        this.$refs.selectedBackground.style.width = `${leftSwitchWidth}px`
      }
      if (!this.firstMountedJobSwitch) {
        this.$emit('change')
      }
      this.firstMountedJobSwitch = false
    }
  },
  watch: {
    value: {
      handler (val, oldVal) {
        this.internalValue = val
      },
      immediate: true
    },
    internalValue (val) {
      this.$emit('input', val)
    },
    '$i18n.locale' (val) {
      this.$nextTick(this.changeTabWidth)
    }
  }
}
</script>

<style lang="scss" scoped>
.switch-content {
  position: relative;
  background-color: #EFEFF1;
  height: 26px;
  border-radius: 40px;

  .selected-background{
    position: absolute;
    background: #0096CC;
    border-radius: 20px;
    height: 100%;
    width: 50px;
    left: 4px;
    z-index: 1;
    transition: all 0.3s linear;
  }
  ::v-deep .el-radio-button__inner {
    font-size: 12px;
    text-align: center;
    line-height: 18px;
    border-radius: 20px;
    padding: 4px 14px 4px;
    box-shadow: unset;
    background: unset;
    color: #909399;
    font-weight: 400;
    border: 0;
    z-index: 1;
  }

  .is-active {
    ::v-deep .el-radio-button__inner {
      color: #FFFFFF;
      border-color: unset;
      background-color: unset;
      box-shadow: unset;
    }
  }
}
</style>
